import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import Tag from "../tag/tag"

const FHKNavBannerWrapper = styled(Link)`
  border: 1px solid ${theme.wild.color.nova.transparency.black[10]};
  margin-top: 24px;
  border-radius: 2px;
  height: 135px;
  display: none;
  align-items: center;
  position: relative;
  overflow: hidden;

  @media (min-width: 1024px) {
    height: 260px;
    border: none;
    align-items: flex-start;
    margin-left: 16px;
  }

  img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    object-fit: cover;
    height: 127%;
    max-width: unset;
    right: -75px;

    @media (min-width: 660px) {
      height: 190%;
      right: -70px;
      transform: translateY(-52%);
    }

    @media (min-width: 1024px) {
      transform: none;
      top: 0;
      right: 0;
      height: 100%;
      width: 100%;
    }
  }

  .content-wrapper {
    min-width: 155px;
    width: 40%;
    padding: 8px;
    z-index: 0;

    @media (min-width: 601px) {
      width: 300px;
      text-align: center;
    }

    @media (min-width: 745px) {
      width: 397px;
    }

    @media (min-width: 1024px) {
      width: 100%;
    }

    .fhk-tag {
      @media (min-width: 768px) {
        padding: 4px;
      }
    }
  }

  .heading {
    @media (max-width: 767px) {
      font-size: 16px;
    }

    @media (min-width: 1024px) {
      font-size: 13px;
    }
  }

  .dashed-circle {
    width: 117px;
    height: 117px;
    position: absolute;
    top: 9px;
    right: 7px;

    @media (min-width: 660px) {
      height: 185px;
      width: 185px;
      top: 50%;
      transform: translateY(-50%);
      right: 49px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    @media (min-width: 1024px) {
      width: 150px;
      height: 150px;
      top: unset;
      bottom: 10px;
      left: 50%;
      right: unset;
      transform: translateX(-50%);
    }

    .line {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(-100%, -50%);
      overflow: hidden;
      width: 15px;

      @media (min-width: 415px) {
        width: 59px;
      }

      @media (min-width: 1024px) {
        width: 32px;
        top: 0;
        left: 39%;
        transform: rotate(90deg) translate(-50%, 0);

        svg {
          width: 59px;
        }
      }
    }

    .dot {
      width: 8px;
      height: 8px;
      border-radius: 9999px;
      background-color: ${theme.wild.color.nova.brand.accent[80]};
      position: absolute;
      top: 50%;
      transform: translate(-50%, -4px);

      @media (min-width: 1024px) {
        top: -4px;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }

    .shop-now-tag {
      position: absolute;
      top: 0;
      right: 0;

      @media (min-width: 660px) {
        top: 42px;
        right: -24px;
      }

      @media (min-width: 660px) and (max-width: 1023px) {
        width: 50px;
        height: 50px;
      }

      @media (min-width: 1024px) {
        width: 51px;
        height: 51px;
        top: -16px;
        right: 0px;
      }
    }
  }
`

const trackFhkClicked = (text, destination) => {
  segmentEvent("Navigation Clicked", {
    module_location: "navigation",
    type: "button",
    text,
    destination,
  })
}

const FHKNavBanner = () => {
  return (
    <FHKNavBannerWrapper
      to="/products/hair-kit/"
      className="fhk-nav-banner"
      onClick={() => trackFhkClicked("Fullest Hair Kit", "/products/hair-kit/")}
    >
      <img
        src="https://images.ctfassets.net/0rbfqd9c4jdo/42zjZ4Aq15Pn8nO4AaxYat/a58c5d9fe7083e0b9c080400d4294d62/fhk-nav-banner-mobile.jpg?fl=progressive"
        alt=""
        className="md:hidden"
      />
      <img
        src="https://images.ctfassets.net/0rbfqd9c4jdo/6etALJO1QzntWEAdkMm727/3198318608be69537e5a5d880823ba45/fhk-nav-banner-desktop.jpg?fl=progressive"
        alt=""
        className="hidden md:block"
      />

      <div className="content-wrapper">
        <Tag
          data={{
            line: "Fullest Hair Kit",
            classes: "fhk-tag bg-nova-brand-accent-80 mb-2 md:mb-1",
          }}
        />

        <TextElementNova
          text="Support thinning from within <br class='hidden md:inline'/>and <br class='hidden min-[601px]:inline md:hidden'/>directly at the scalp."
          className="heading Title-10-Super-Normal"
        />
      </div>

      <div className="dashed-circle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="117"
          height="117"
          viewBox="0 0 117 117"
          fill="none"
          className="circle"
        >
          <circle
            cx="58.5"
            cy="58.5"
            r="58.1838"
            stroke="#041C1B"
            strokeWidth="0.632432"
            strokeDasharray="0.53 3.16"
          />
        </svg>

        <div className="line">
          <svg
            width="59"
            height="1"
            viewBox="0 0 59 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="-4.37114e-08"
              y1="0.5"
              x2="59"
              y2="0.499995"
              stroke="#041C1B"
              strokeDasharray="0.83 5"
            />
          </svg>
        </div>

        <div className="dot" />

        <div className="shop-now-tag">
          <svg
            width="40"
            height="41"
            viewBox="0 0 40 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20.5" r="20" fill="#007A73" />
            <path
              d="M9.9493 18.7809C9.4613 18.7809 8.9693 18.7129 8.4733 18.5769C7.9773 18.4329 7.5453 18.2409 7.1773 18.0009V15.6849H7.5613C7.8413 17.3569 8.7013 18.1929 10.1413 18.1929C10.6533 18.1929 11.0653 18.0769 11.3773 17.8449C11.6893 17.6129 11.8453 17.2289 11.8453 16.6929C11.8453 16.3089 11.7453 16.0049 11.5453 15.7809C11.3533 15.5569 11.0053 15.3329 10.5013 15.1089L9.0133 14.4609C8.4373 14.2209 8.0053 13.9249 7.7173 13.5729C7.4373 13.2129 7.2973 12.7849 7.2973 12.2889C7.2973 11.5849 7.5493 11.0249 8.0533 10.6089C8.5653 10.1849 9.2893 9.9729 10.2253 9.9729C11.0893 9.9729 11.8733 10.1529 12.5773 10.5129V12.6729H12.2293C12.0693 11.9049 11.7933 11.3609 11.4013 11.0409C11.0173 10.7129 10.5333 10.5489 9.9493 10.5489C9.4053 10.5489 8.9893 10.6649 8.7013 10.8969C8.4213 11.1289 8.2813 11.4529 8.2813 11.8689C8.2813 12.1809 8.3813 12.4569 8.5813 12.6969C8.7893 12.9369 9.1453 13.1609 9.6493 13.3689L11.1733 14.0289C11.7573 14.2849 12.1853 14.5889 12.4573 14.9409C12.7293 15.2929 12.8653 15.7329 12.8653 16.2609C12.8653 16.7489 12.7493 17.1849 12.5173 17.5689C12.2853 17.9449 11.9493 18.2409 11.5093 18.4569C11.0693 18.6729 10.5493 18.7809 9.9493 18.7809ZM13.3493 18.2769C13.6373 18.2449 13.8453 18.2049 13.9733 18.1569C14.1093 18.1089 14.2053 18.0329 14.2613 17.9289C14.3173 17.8169 14.3453 17.6489 14.3453 17.4249V10.7289C14.3453 10.4889 14.3093 10.3289 14.2373 10.2489C14.1653 10.1689 14.0213 10.1289 13.8053 10.1289C13.6933 10.1289 13.5533 10.1409 13.3853 10.1649V9.9009L15.0653 9.4569H15.3653V12.3369C15.3653 12.7529 15.3493 13.0849 15.3173 13.3329C15.2853 13.5809 15.2293 13.8369 15.1493 14.1009L15.2093 14.1249C15.3533 13.6289 15.6093 13.2449 15.9773 12.9729C16.3453 12.6929 16.7933 12.5529 17.3213 12.5529C17.8733 12.5529 18.3133 12.7209 18.6413 13.0569C18.9773 13.3929 19.1453 13.9249 19.1453 14.6529V17.4249C19.1453 17.6569 19.1733 17.8249 19.2293 17.9289C19.2853 18.0329 19.3773 18.1089 19.5053 18.1569C19.6413 18.2049 19.8533 18.2449 20.1413 18.2769V18.5769H17.3333V18.2769C17.6453 18.2129 17.8533 18.1369 17.9573 18.0489C18.0693 17.9529 18.1253 17.7929 18.1253 17.5689V14.8209C18.1253 14.3249 18.0093 13.9569 17.7773 13.7169C17.5533 13.4769 17.2413 13.3569 16.8413 13.3569C16.4653 13.3569 16.1613 13.4329 15.9293 13.5849C15.6973 13.7369 15.5093 13.9649 15.3653 14.2689V17.4249C15.3653 17.6409 15.3893 17.8049 15.4373 17.9169C15.4853 18.0209 15.5653 18.1009 15.6773 18.1569C15.7893 18.2049 15.9613 18.2449 16.1933 18.2769V18.5769H13.3493V18.2769ZM23.3867 18.7209C22.8187 18.7209 22.3107 18.5849 21.8627 18.3129C21.4147 18.0409 21.0667 17.6729 20.8187 17.2089C20.5707 16.7369 20.4467 16.2129 20.4467 15.6369C20.4467 15.0609 20.5707 14.5409 20.8187 14.0769C21.0667 13.6049 21.4147 13.2329 21.8627 12.9609C22.3107 12.6889 22.8187 12.5529 23.3867 12.5529C23.9547 12.5529 24.4627 12.6889 24.9107 12.9609C25.3587 13.2329 25.7067 13.6049 25.9547 14.0769C26.2027 14.5409 26.3267 15.0609 26.3267 15.6369C26.3267 16.2129 26.2027 16.7369 25.9547 17.2089C25.7067 17.6729 25.3587 18.0409 24.9107 18.3129C24.4627 18.5849 23.9547 18.7209 23.3867 18.7209ZM23.3867 18.1929C24.5307 18.1929 25.1027 17.3409 25.1027 15.6369C25.1027 13.9329 24.5307 13.0809 23.3867 13.0809C22.2427 13.0809 21.6707 13.9329 21.6707 15.6369C21.6707 17.3409 22.2427 18.1929 23.3867 18.1929ZM26.7144 20.9769C27.0024 20.9449 27.2104 20.9049 27.3384 20.8569C27.4744 20.8089 27.5704 20.7289 27.6264 20.6169C27.6824 20.5129 27.7104 20.3489 27.7104 20.1249V13.9929C27.7104 13.7929 27.6664 13.6529 27.5784 13.5729C27.4984 13.4849 27.3624 13.4409 27.1704 13.4409C27.0664 13.4409 26.8864 13.4489 26.6304 13.4649V13.1649L28.3224 12.6969H28.5984V13.3689C28.5984 13.5129 28.5704 13.7529 28.5144 14.0889L28.5624 14.1009C28.7144 13.6209 28.9744 13.2449 29.3424 12.9729C29.7184 12.6929 30.1424 12.5529 30.6144 12.5529C31.0784 12.5529 31.4864 12.6649 31.8384 12.8889C32.1904 13.1129 32.4624 13.4329 32.6544 13.8489C32.8464 14.2649 32.9424 14.7449 32.9424 15.2889C32.9424 15.9449 32.8184 16.5369 32.5704 17.0649C32.3224 17.5849 31.9784 17.9929 31.5384 18.2889C31.0984 18.5769 30.5984 18.7209 30.0384 18.7209C29.5584 18.7209 29.1224 18.6009 28.7304 18.3609V20.1249C28.7304 20.3489 28.7664 20.5169 28.8384 20.6289C28.9104 20.7409 29.0304 20.8209 29.1984 20.8689C29.3664 20.9169 29.6224 20.9529 29.9664 20.9769V21.2769H26.7144V20.9769ZM30.0624 18.2529C30.5984 18.2529 31.0264 18.0249 31.3464 17.5689C31.6744 17.1049 31.8384 16.4889 31.8384 15.7209C31.8384 15.0009 31.6944 14.4489 31.4064 14.0649C31.1264 13.6729 30.7184 13.4769 30.1824 13.4769C29.8544 13.4769 29.5624 13.5449 29.3064 13.6809C29.0504 13.8169 28.8584 14.0089 28.7304 14.2569V17.6289C28.9304 17.8449 29.1344 18.0049 29.3424 18.1089C29.5584 18.2049 29.7984 18.2529 30.0624 18.2529Z"
              fill="white"
            />
            <path
              d="M15.6428 30.5769H12.8348V30.2769C13.1468 30.2289 13.3548 30.1569 13.4588 30.0609C13.5708 29.9569 13.6268 29.7929 13.6268 29.5689V26.8449C13.6268 26.3409 13.5148 25.9689 13.2908 25.7289C13.0748 25.4809 12.7628 25.3569 12.3548 25.3569C11.6268 25.3569 11.1308 25.6569 10.8668 26.2569V29.4249C10.8668 29.7449 10.9188 29.9569 11.0228 30.0609C11.1348 30.1649 11.3588 30.2369 11.6948 30.2769V30.5769H8.85078V30.2769C9.13078 30.2529 9.33878 30.2169 9.47478 30.1689C9.61078 30.1209 9.70678 30.0409 9.76278 29.9289C9.81878 29.8169 9.84678 29.6489 9.84678 29.4249V25.8249C9.84678 25.6889 9.79478 25.5889 9.69078 25.5249C9.59478 25.4609 9.46278 25.4289 9.29478 25.4289C9.21478 25.4289 9.04278 25.4409 8.77878 25.4649V25.1649L10.4708 24.6969H10.7468V25.3569C10.7468 25.5409 10.7148 25.7889 10.6508 26.1009L10.7108 26.1129C10.8708 25.6169 11.1308 25.2329 11.4908 24.9609C11.8588 24.6889 12.3068 24.5529 12.8348 24.5529C13.3868 24.5529 13.8268 24.7209 14.1548 25.0569C14.4828 25.3929 14.6468 25.9249 14.6468 26.6529V29.4249C14.6468 29.6569 14.6748 29.8289 14.7308 29.9409C14.7868 30.0449 14.8828 30.1209 15.0188 30.1689C15.1548 30.2169 15.3628 30.2529 15.6428 30.2769V30.5769ZM18.885 30.7209C18.317 30.7209 17.809 30.5849 17.361 30.3129C16.913 30.0409 16.565 29.6729 16.317 29.2089C16.069 28.7369 15.945 28.2129 15.945 27.6369C15.945 27.0609 16.069 26.5409 16.317 26.0769C16.565 25.6049 16.913 25.2329 17.361 24.9609C17.809 24.6889 18.317 24.5529 18.885 24.5529C19.453 24.5529 19.961 24.6889 20.409 24.9609C20.857 25.2329 21.205 25.6049 21.453 26.0769C21.701 26.5409 21.825 27.0609 21.825 27.6369C21.825 28.2129 21.701 28.7369 21.453 29.2089C21.205 29.6729 20.857 30.0409 20.409 30.3129C19.961 30.5849 19.453 30.7209 18.885 30.7209ZM18.885 30.1929C20.029 30.1929 20.601 29.3409 20.601 27.6369C20.601 25.9329 20.029 25.0809 18.885 25.0809C17.741 25.0809 17.169 25.9329 17.169 27.6369C17.169 29.3409 17.741 30.1929 18.885 30.1929ZM26.6481 26.5089C26.6161 26.7089 26.5401 26.9569 26.4201 27.2529L25.0041 30.6369H24.6921L22.4961 25.5729C22.3841 25.3329 22.2801 25.1769 22.1841 25.1049C22.0881 25.0329 21.9281 24.9969 21.7041 24.9969V24.6969H24.3681V24.9969C24.1121 24.9969 23.9281 25.0329 23.8161 25.1049C23.7041 25.1689 23.6481 25.2769 23.6481 25.4289C23.6481 25.5169 23.6881 25.6649 23.7681 25.8729L24.8121 28.3689C24.8921 28.5449 24.9441 28.7009 24.9681 28.8369C24.9921 28.9649 25.0041 29.1449 25.0041 29.3769H25.0641C25.0881 29.1609 25.1521 28.9129 25.2561 28.6329L26.3601 26.0889L26.1321 25.5729C26.0201 25.3249 25.9161 25.1689 25.8201 25.1049C25.7321 25.0329 25.5761 24.9969 25.3521 24.9969V24.6969H28.1961V24.9969C27.8441 24.9969 27.6041 25.0289 27.4761 25.0929C27.3561 25.1489 27.2961 25.2609 27.2961 25.4289C27.2961 25.5249 27.3281 25.6689 27.3921 25.8609L28.4361 28.4169C28.5641 28.7289 28.6281 29.0649 28.6281 29.4249H28.6881C28.7121 29.2009 28.7761 28.9529 28.8801 28.6809L30.0441 25.8969C30.1161 25.7129 30.1521 25.5649 30.1521 25.4529C30.1521 25.2689 30.0841 25.1489 29.9481 25.0929C29.8201 25.0289 29.5641 24.9969 29.1801 24.9969V24.6969H31.5201V24.9969C31.3121 24.9969 31.1481 25.0409 31.0281 25.1289C30.9081 25.2089 30.8081 25.3529 30.7281 25.5609L28.6401 30.6369H28.3281L26.8641 27.2529C26.7601 27.0209 26.7081 26.7729 26.7081 26.5089H26.6481Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </FHKNavBannerWrapper>
  )
}

export default FHKNavBanner
